define.alias("checkout/components/alert-banner", "calendar/components/alert-banner");